"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssReset = _interopRequireDefault(require("./cssReset"));
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _utils.selectSystemProps)([_utils.a11yProps, _utils.htmlAttrs]);

/**
 * On Web, wraps children with a HTML `<fieldset>` and sets its attributes as necessary.
 */
const FieldsetContainer = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    children,
    inactive,
    accessibilityRole,
    name: fieldsetName,
    showBorderStyle = false,
    borderStyle,
    style,
    ...rest
  } = _ref;
  // If needs border for error design or reset the component style
  const styleContainer = showBorderStyle && borderStyle ? borderStyle : _cssReset.default;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("fieldset", {
    ref: ref,
    disabled: inactive,
    style: {
      ...styleContainer,
      ...style
    },
    role: accessibilityRole,
    name: fieldsetName,
    ...selectProps(rest),
    children: children
  });
});
FieldsetContainer.displayName = 'FieldsetContainer';
FieldsetContainer.propTypes = {
  ...selectedSystemPropTypes,
  accessibilityRole: _propTypes.default.string,
  children: _propTypes.default.node,
  inactive: _propTypes.default.bool,
  name: _propTypes.default.string,
  showBorderStyle: _propTypes.default.bool,
  borderStyle: _propTypes.default.object,
  style: _propTypes.default.object
};
var _default = exports.default = FieldsetContainer;